import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Components
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { CallbackComponent } from './callback/callback.component';
import { ToastComponent } from './toast/toast.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';

// NGRX related
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { CustomRouterStateSerializer } from './shared/utils';
import { reducers, metaReducers } from './reducers';
import { SitesEffects } from './sites/store/effects/sites.effects';

// Misc.
import { environment } from '../environments/environment';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { UsersEffects } from './users/store/effects/users.effects';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalService, MSAL_INSTANCE } from './msal';

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.msal.clientId,
			redirectUri: environment.msal.redirectUri,
			authority: environment.msal.authority,
			navigateToLoginRequestUrl: false,
		},
		cache: {
			cacheLocation: 'localStorage',
		},
	});
}

@NgModule({
	declarations: [AppComponent, CallbackComponent, ToastComponent, ForbiddenComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		AuthModule,
		HttpClientModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		StoreRouterConnectingModule.forRoot({
			stateKey: 'router',
		}),
		EffectsModule.forRoot([SitesEffects, UsersEffects]),
		!environment.production ? StoreDevtoolsModule.instrument() : [],
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		MsalService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
